import React from 'react'
import {Container, Typography, Box, Button, CircularProgress} from '@mui/material'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../redux/rootReducer'
import {actions as userActions} from '../../redux/modules/users'
import styles from './styles'
import {ModalPage} from 'nav/ModalPage'

const AutoResetPasswordPage: ModalPage = props => {
  const dispatch = useDispatch()
  const {loading, autoResetPasswordResponse } = useSelector((state: RootState) => state.users)
  const {onClickCancel} = props

  const closePage = () => {
    dispatch(userActions.setError({error: undefined}))
    dispatch(userActions.setAutoResetPassword({message: '', newPassword: ''}))
    onClickCancel()
  }

  return (
    <Container component="main">
      <Box sx={styles.mainModal}>
        <Box sx={styles.modal}>
          <Typography variant="h4" sx={styles.headerLabel}>
            Auto regenerated password
          </Typography>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : (
            <>
              <Typography>{autoResetPasswordResponse?.message}</Typography>
              <Typography sx={{mt: 2}}>
                New Password:{' '}
                <Box component="span" fontWeight="bold">
                  {autoResetPasswordResponse?.newPassword}
                </Box>
              </Typography>
            </>
          )}
          <Box sx={styles.buttonContainer}>
            <Button onClick={closePage} variant="contained">
              Close
            </Button>
            {loading && (
              <Box sx={styles.progress}>
                <CircularProgress size={10} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default AutoResetPasswordPage
